export default __webpack_public_path__ + "5e24a16b8aae3a0dc7dad462e4c8eeaf.png";